import { useState } from 'react';
import { DOC_KINDS, DOC_KIND_LABELS } from './DocUploadForm.jsx';
import { useUpdateDocument } from '../../hooks/useDocuments.js';
import { useError } from '../shared/ErrorBanner.jsx';

export default function DocEditForm({ doc, onDone }) {
  const [kind, setKind] = useState(doc.kind);
  const [label, setLabel] = useState(doc.label || '');
  const [expires, setExpires] = useState(
    doc.expires_at ? new Date(doc.expires_at).toISOString().slice(0, 10) : ''
  );
  const [notes, setNotes] = useState(doc.notes || '');
  const update = useUpdateDocument();
  const { show } = useError();

  const save = async (e) => {
    e.preventDefault();
    try {
      await update.mutateAsync({
        id: doc.id,
        kind, label: label || null, expires_at: expires || null, notes: notes || null,
      });
      onDone();
    } catch (err) { show(err.message); }
  };

  return (
    <form onSubmit={save} style={{ padding: 16, background: 'var(--surface-container)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 8 }}>
        <div className="field">
          <label className="field-label">Kind</label>
          <select className="field-select" value={kind} onChange={e => setKind(e.target.value)}>
            {DOC_KINDS.map(k => <option key={k} value={k}>{DOC_KIND_LABELS[k]}</option>)}
          </select>
        </div>
        <div className="field">
          <label className="field-label">Label</label>
          <input className="field-input" value={label} onChange={e => setLabel(e.target.value)} />
        </div>
      </div>
      <div className="field">
        <label className="field-label">Expires</label>
        <input className="field-input" type="date" value={expires} onChange={e => setExpires(e.target.value)} />
      </div>
      <div className="field">
        <label className="field-label">Notes</label>
        <textarea className="field-textarea" value={notes} onChange={e => setNotes(e.target.value)} />
      </div>
      <button className="btn-sm primary" type="submit" disabled={update.isPending}>
        {update.isPending ? 'Saving…' : 'Save'}
      </button>
    </form>
  );
}
